var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 31.5,
    r: 31.5,
    fill: "#E0E6F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1233_287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.7538 40.9632L23.2761 45.441C21.4197 47.2973 18.4134 47.2973 16.5586 45.4413C14.7034 43.5861 14.7034 40.5796 16.5583 38.7248L25.5152 29.7678C27.3701 27.9129 30.3766 27.9129 32.2314 29.7678C32.8497 30.3861 33.8523 30.3861 34.4706 29.7678C35.0889 29.1495 35.0889 28.1469 34.4706 27.5286C31.3791 24.4371 26.3676 24.4371 23.2761 27.5286L14.3191 36.4855C11.2276 39.577 11.2276 44.5886 14.3191 47.6801C17.4103 50.7732 22.4222 50.7732 25.5153 47.6801L29.993 43.2024C30.6114 42.584 30.6114 41.5815 29.993 40.9632C29.3747 40.3448 28.3721 40.3449 27.7538 40.9632Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.681 14.3186C44.5895 11.2271 39.5763 11.2271 36.4848 14.3186L31.1125 19.6909C30.4942 20.3092 30.4942 21.3117 31.1125 21.9301C31.7308 22.5484 32.7334 22.5484 33.3517 21.9301L38.724 16.5578C40.5788 14.7029 43.5869 14.7029 45.4418 16.5578C47.2966 18.4126 47.2966 21.4191 45.4418 23.2739L35.5902 33.1256C33.7354 34.9805 30.7289 34.9805 28.8741 33.1256C28.2558 32.5073 27.2532 32.5073 26.6349 33.1256C26.0166 33.7439 26.0166 34.7464 26.6349 35.3648C29.7264 38.4563 34.7379 38.4563 37.8294 35.3648L47.681 25.5132C50.7725 22.4217 50.7725 17.4101 47.681 14.3186Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1233_287"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyLink);
export default __webpack_public_path__ + "static/media/copy-link.09df57619fdccef1dd52734c3dfe1beb.svg";
export { ForwardRef as ReactComponent };